export default class TypePolicyInsurance {
  id!: number
  policy_type!: string
  isEdit!: boolean
}
